import { AuthService } from './../_services/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HTTP_INTERCEPTORS,
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  Observable,
  Subject,
  catchError,
  endWith,
  from,
  of,
  tap,
  throwError,
} from 'rxjs';
import { Router } from '@angular/router';
import { User } from '../_models/user.model';
import { RestRoutes } from '../_config/rest-routes.config';
import { SecurityConstants } from '../_config/security-constants.config';
import { Routes } from '../_config/routes.config';
import { environment } from 'src/environments/environment';
import { HttpEventService } from '../_services/http-event-service.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private httpEventService:HttpEventService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.endsWith(RestRoutes.AUTH + '/AuthJwt')) {
      return next.handle(req);
    }
    let authReq = req;
    const token = this.authService.getToken();
    if (token != null) {
      authReq = req.clone({
        headers: req.headers.set(
          SecurityConstants.TOKEN_HEADER_KEY,
          `${SecurityConstants.TOKEN_PREFIX} ${token}`,
        ),
        //withCredentials: true
      });
    }
    //return next.handle(authReq);
    // comprueba si hay un error y si es de auth procede a deslogar
    return next
      .handle(authReq)
      .pipe(catchError((err) => this.handleAuthError(err)));
  }
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    //if (!err.url.endsWith(RestRoutes.PW_RESET) && (err.status === 401 || err.status === 403)) {

    if (!err.url.endsWith(RestRoutes.PW_RESET) && err.status === 401) {
      //navigate /delete cookies or whatever
      this.authService.logOut();
      if (environment.logOutUrl != '') {
        this.router.navigate([Routes.LOGOUT]);
      } else {
        this.router.navigate([Routes.LOGIN]);
      }
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return of(err.message); // or EMPTY may be appropriate here
    }
    if(err.name == "HttpErrorResponse" && err.status == 0){
      this.httpEventService.emitError(err);
    }
    throw err;
  }
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
];
